import {
  required,
  badWords,
  disallowHtml,
  maxLength,
  isEmail,
} from '@seek/validators-js';

import { useField } from '../../EnquiryForm';

export const useFields = ({ isANZ = true }: { isANZ: boolean }) => {
  const subject = useField({
    id: 'subject',
    validators: [required],
  });
  const reason = useField({
    id: 'reason',
    /* Skip the validation unless it is on ANZ*/
    validators: isANZ ? [required] : [],
  });
  const firstName = useField({
    id: 'firstName',
    validators: [required, badWords, disallowHtml, maxLength] as any,
    validatorProps: { max: 100 },
  });
  const lastName = useField({
    id: 'lastName',
    validators: [required, badWords, disallowHtml, maxLength] as any,
    validatorProps: { max: 100 },
  });
  const email = useField({
    id: 'email',
    validators: [required, disallowHtml, isEmail, maxLength] as any,
    validatorProps: { max: 100 },
  });
  const company = useField({
    id: 'company',
    validators: [required, disallowHtml, maxLength] as any,
    validatorProps: { max: 100 },
  });
  const additionalInformation = useField({
    id: 'additionalInformation',
    validators: [required, badWords, disallowHtml, maxLength] as any,
    validatorProps: { max: 1000 },
  });

  return {
    subject,
    reason,
    firstName,
    lastName,
    email,
    company,
    additionalInformation,
  };
};
